import { render } from "./Incidencias.vue?vue&type=template&id=1641cae6&scoped=true"
import script from "./Incidencias.vue?vue&type=script&lang=js"
export * from "./Incidencias.vue?vue&type=script&lang=js"

import "./Incidencias.vue?vue&type=style&index=0&id=1641cae6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1641cae6"]])

export default __exports__